import { Button, Dialog, DialogActions, DialogTitle, DialogContent } from "@mui/material";
import { memo, useEffect, useState } from "react";

interface Photo {
  isOpen: boolean;
  handleClose: any;
  message: any;
  result: string;
}

const ShowPhoto = memo(function ShowThePhoto(props: Photo) {
  const [open, setOpen] = useState(false);
  useEffect(() => {
    setOpen(props.isOpen);
  }, []);
  const handleClose = (event: any, reason: any) => {
    if (reason === "escapeKeyDown" || reason === "backdropClick") return;
    props.handleClose();
  };

  return (
    <div>
      <Dialog
        open={open}
        onClose={handleClose}
      >
        <DialogTitle id="responsive-dialog-title">
          {props.result}
        </DialogTitle>
        <DialogContent>
          <img src={props.message} alt="" style={{width:"600px", height: "400px"}}/>
        </DialogContent>
        <DialogActions sx={{ justifyContent: "center" }}>
          <Button color="error" onClick={props.handleClose}>
            CANCEL
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
});

export default ShowPhoto;

